import { Injectable, Type } from '@angular/core';
import { ConfiguratorConfig } from './configurator-config.interface';

/**
 * Centralne repozytorium konfiguratorów
 * Przechowuje klasy konfiguracji (nie instancje)
 */
@Injectable({
    providedIn: 'root'
})
export class ConfigurationsRegistry {
    private static configs = new Map<string, ConfiguratorConfig>();

    static register(config: ConfiguratorConfig): void {
        this.configs.set(config.type, config);
    }

    static getConfig(type: string): ConfiguratorConfig | undefined {
        return this.configs.get(type);
    }

    static getActiveConfigurationClass<T = any>(type: string): Type<T> | undefined {
        const config = this.configs.get(type);
        return config?.activeConfigurationClass as Type<T>;
    }

    static getConfigurationClass<T = any>(type: string): Type<T> | undefined {
        const config = this.configs.get(type);
        return config?.configurationClass as Type<T>;
    }

    static has(type: string): boolean {
        return this.configs.has(type);
    }

    static getRegisteredTypes(): string[] {
        return Array.from(this.configs.keys());
    }
}
